// src/components/Sockets/SocketStatus.tsx
import { useEffect, useState } from "react";
import { socket } from "@/lib/socket"; // <-- your socket instance

interface PresenceInfo {
    socketId: string;
    userRole: string;
    dealerRoom: string;
    page?: string;
    vehicleId?: string;
}

const SocketStatus = () => {
    const [connected, setConnected] = useState(socket.connected);
    const [presence, setPresence] = useState<PresenceInfo[]>([]);

    useEffect(() => {
        const onConnect = () => setConnected(true);
        const onDisconnect = () => setConnected(false);

        socket.on("connect", onConnect);
        socket.on("disconnect", onDisconnect);


        socket.on("presenceUpdate", (list: PresenceInfo[]) => {
            setPresence(list);
        });

        // cleanup
        return () => {
            socket.off("connect", onConnect);
            socket.off("disconnect", onDisconnect);
            socket.off("presenceUpdate");
        };
    }, []);

    return (
        <div className="fixed bottom-2 right-2 bg-primary text-primary-foreground border rounded shadow p-2 text-xs z-50">
            <div className={connected ? "text-green-600" : "text-red-600"}>
                {connected ? "Connected" : "Disconnected"}
            </div>
            {connected && (
                <div className="mt-1">
                    <strong>Online:</strong>
                    <ul>
                        {presence.map((p) => (
                            <li key={p.socketId}>
                                [{p.userRole}] {p.dealerRoom} {p.page && `→ ${p.page}`}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default SocketStatus;
